import { render, staticRenderFns } from "./icon-bold.vue?vue&type=template&id=83643d7c"
import script from "./icon-bold.vue?vue&type=script&lang=js"
export * from "./icon-bold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports